module.exports = __webpack_public_path__ + "img/icons BFr_26.a20036c0.svg";